var render = function render(){var _vm=this,_c=_vm._self._c;return _c('avs-card',{attrs:{"noTitle":""},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticStyle:{"height":"350px"},attrs:{"id":"tl-ref"}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }